import { useTranslation } from 'react-i18next';

import { FormTextField } from '~/components/atoms/form-fields/FormTextField';
import ContentQRBuilderHeader from '~/components/builder/ContentQRBuilderHeader';
import NameAndOrganizationBlock from '~/components/builder/NameAndOrganizationBlock';
import QrTypeTopCard from '~/components/builder/QrTypeTopCard';
import Accordion from '~/components/ui/Accordion/Accordion';
import { QRCODE_STATIC_TYPE } from '~/constants/qr-code';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { StyledFormContainer } from '~/pages/qrBuilder/p-static/commonStyled';
import { ContactInfoContent } from '~/pages/qrBuilder/p-static/p-static-v-card/p-static-v-card-content/components/contact-info-content/ContactInfoContent';
import { LocationContent } from '~/pages/qrBuilder/p-static/p-static-v-card/p-static-v-card-content/components/location-content/LocationContent';

import { StyledContainer } from './styled';
// import PasswordProtectionBlock from '~/components/builder/PasswordProtectionBlock';

export const StaticVCardForm = () => {
  const { t } = useTranslation();

  return (
    <StyledFormContainer>
      <ContentQRBuilderHeader />
      <QrTypeTopCard type={QRCODE_STATIC_TYPE.VCARD} />
      <CreateQRContentBlockLayout defaultExpanded type="basicInfo">
        <Accordion
          defaultExpanded
          variant="child"
          summary={t('template5:about')}
          details={
            <StyledContainer>
              <FormTextField name="firstName" fullWidth label={t('settings:name')} inputProps={{ maxLength: 70 }} />
              <FormTextField name="lastName" fullWidth label={t('settings:surname')} inputProps={{ maxLength: 70 }} />
            </StyledContainer>
          }
        />
        <Accordion
          defaultExpanded
          variant="child"
          summary={t('template5:constactInfo')}
          details={<ContactInfoContent />}
        />
        <Accordion defaultExpanded variant="child" summary={t('template5:location')} details={<LocationContent />} />
        <Accordion
          defaultExpanded
          variant="child"
          hideBottomBorder
          summary={t('other:company')}
          details={
            <StyledContainer>
              <FormTextField name="companyName" fullWidth label={t('other:company')} inputProps={{ maxLength: 50 }} />
              <FormTextField name="companyPosition" fullWidth label={t('other:title')} inputProps={{ maxLength: 50 }} />
            </StyledContainer>
          }
        />
      </CreateQRContentBlockLayout>
      <NameAndOrganizationBlock isStatic />
      {/*<PasswordProtectionBlock />*/}
    </StyledFormContainer>
  );
};
